<template>
  <p class="helptext" v-if="helpText">{{ helpText }}</p>
</template>

<script>
import BaseComponent from "../../BaseComponent";

/**
 * @group Inputs - parts
 * Text that assists the user in what to put in the input they are currently handling.
 */

export default {
  name: "InputHelpText",
  mixins: [BaseComponent],
  props: {
    helpText: {
      type: String,
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../style_variables/style_variables.scss";
.helptext {
  @extend %body2_style;
  margin: 0px;
  font-size: 12px;
  color: $grey_manatee;
}
</style>
